
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-with-locales-es6';
import {  DatePicker } from 'react-responsive-ui'
import Loading from '../components/Loading';
import { getMeasuresForUser, getMeasuresModes } from '../helpers/registrationHelper';
import ECGImage from '../components/ECGImage';

var AmCharts = require("@amcharts/amcharts3-react");
require('./../')

function getImage(item) {
  var imgPath = ""
  if (item.measure_type_id === 7) {
    imgPath = require("./../images/ECG_Icon.png")
    return <span>
      <img src={imgPath} />
      <ECGImage item={item} />
    </span>
  } else if (item.measure_type_id === 3) {
    return <div className="sleep-time-container">{item.value}</div>
  } else if (item.measure_type_id === 9) {
    return <div className="calories-container">{item.value}</div>
  } else {
    switch (item.value) {
      case "0":
        imgPath = require(`./../images/${getImageName(item.measure_type_id)}_Icon-0.png`);
        break;
      case "1":
        imgPath = require(`./../images/${getImageName(item.measure_type_id)}_Icon-1.png`);
        break;
      case "2":
        imgPath = require(`./../images/${getImageName(item.measure_type_id)}_Icon-2.png`);
        break;
      default:
        imgPath = require(`./../images/${getImageName(item.measure_type_id)}_Icon-0.png`);
        break;
    }
    return <img src={imgPath} />;
  }
}

function getImageName(measure_type_id) {
  switch (measure_type_id) {
    case 4: return 'Energy'
    case 5: return 'Mood'
    default: return 'Mood'
  }
}

function convertDecimalToTime(_decimalValue) {
  let a = moment.duration(_decimalValue, 'hours')
  return `${a._data.hours}:${a._data.minutes > 9 ? a._data.minutes : `0${a._data.minutes}`}`
}

function getGuideFillColor(mode_type) {
  return "red";
}

function generateGuides(modes) {
  var modesToReturn = []
  modes.forEach(function (mode) {

    modesToReturn.push(
      {
        "valueAxis": "v1",
        "date": new Date(mode.start_date),
        "toDate": new Date(mode.end_date),
        "lineAlpha": 0,
        "fillColor": getGuideFillColor(mode.mode_type),
        "fillAlpha": 0.25,
        "tickLength": 0,
        "expand": true,
        "inside": true,
        "labelRotation": 90,
        "label": `${mode.mode_type}`,
        "balloonText": `Additional information on ${mode.mode_type}`
      }
    )
  });

  return modesToReturn
}

function generateData(_data, start_date, end_date, systolicData) {
  var dataProvider = [];
  if (!_data.measures) {
    return []
  } else {
    let start = moment(start_date)
    let end = moment(end_date)

    var measures = _data.measures
    if (start.diff(end) === 0) {
      measures = measures.sort(function (a, b) { return a.x - b.x })
      if (systolicData)
        var systolicMeasures = systolicData.measures.sort(function (a, b) { return a.x - b.x })
      for (var i = 0; i < measures.length - 1; i++) {
        dataProvider.push({
          date: convertDecimalToTime(measures[i].x),
          g1: measures[i].y
        });
        if (systolicData && systolicMeasures[i])
          dataProvider.push({
            date: convertDecimalToTime(systolicMeasures[i].x),
            g2: systolicMeasures[i].y
          });
      }
    } else {
      if (systolicData) {
        measures = measures.concat(systolicData.measures)
      }
      for (var i = 0; i < measures.length; i++) {
        if (measures[i])
          for (var y = 0; y < measures[i].length - 1; y++) {
            switch (i) {
              case 0:
                dataProvider.push({
                  date: measures[i][y].x,
                  g1: measures[i][y].y,
                })
                break
              case 1:
                dataProvider.push({
                  date: measures[i][y].x,
                  g2: measures[i][y].y,
                })
                break
              case 2:
                dataProvider.push({
                  date: measures[i][y].x,
                  g3: measures[i][y].y,
                })
                break
              case 3:
                dataProvider.push({
                  date: measures[i][y].x,
                  g4: measures[i][y].y,
                })
                break
              case 4:
                dataProvider.push({
                  date: measures[i][y].x,
                  g4: measures[i][y].y,
                })
                break
              case 5:
                dataProvider.push({
                  date: measures[i][y].x,
                  g5: measures[i][y].y,
                })
                break
              case 6:
                dataProvider.push({
                  date: measures[i][y].x,
                  g6: measures[i][y].y,
                })
                break
              case 7:
                dataProvider.push({
                  date: measures[i][y].x,
                  g7: measures[i][y].y,
                })
                break
              default: break;
            }

          }
      }
    }
    return dataProvider;
  }
}

function parseDateForAPI(_date) {
  return moment(_date).format('L')
}

function getMeasureTypeID(_url) {
  let pageName = _url.split('/')[_url.split('/').length - 1]
  switch (pageName) {
    case 'heart-rate': return 2;
    case 'breath-rate': return 6;
    case 'blood-pressure': return 1;//1-8 
    case 'mood': return 5;
    case 'energy': return 4;
    case 'sleep': return 3;
    case 'ecg': return 7;
    case 'calories': return 9;
    case 'steps': return 10;
    default: console.log('no measure_type_id for this path'); break;
  }

}

class Measures extends React.Component {

  constructor(props) {
    super(props)
    moment.locale('en-ca')
    let measure_type = props.measure_type_id ? props.measure_type_id : getMeasureTypeID(props.history.location.pathname)
    let user_id = props && props.user_id ? props.user_id : localStorage.user_id

    this.state = {
      dataProvider: generateData([]),
      timer: null,
      measure_type_id: measure_type,
      start_date: new Date(),
      end_date: new Date(),
      modes: [],
      user_id: user_id
    }

    this.changedEndDate = this.changedEndDate.bind(this)
    this.changedStartDate = this.changedStartDate.bind(this)
    this.getMeasures = this.getMeasures.bind(this)
    this.getModes = this.getModes.bind(this)
    this.verifyMeasureTypeiD = this.verifyMeasureTypeiD.bind(this)
    this.getMeasures()
    this.getModes()

    this.verifyMeasureTypeiD()
    if (!this.props.measure_type_id) {
      this.props.history.listen((location) => {
        this.setState({ measure_type_id: getMeasureTypeID(location.pathname) }, () => {
          this.verifyMeasureTypeiD()
          this.getMeasures()
        })
      }).bind(this);
    }
  }

  verifyMeasureTypeiD() {
    this.setState({ isListMeasures: [3, 4, 5, 7, 9, 10].includes(this.state.measure_type_id) })
  }

  getModes() {
    getMeasuresModes(parseDateForAPI(this.state.start_date), parseDateForAPI(this.state.end_date))
      .then((response) => {
        if (response.data) {
          this.setState({ guides: generateGuides(response.data) })
        } else {
          console.log('error while getting modes')
        }
      })
  }

  componentWillReceiveProps = (props) => {
    if (props.measure_type_id !== this.props.measure_type_id) {
      console.log('switching measure type id')
      this.setState({ measure_type_id: props.measure_type_id }, () => {
        this.verifyMeasureTypeiD()
        this.getMeasures()
      })
    }
  }

  componentDidMount() {
    this.verifyMeasureTypeiD()
  }

  getMeasures() {
    let startDate = this.state.start_date
    let endDate = this.state.end_date
    let userID = this.state.user_id ? this.state.user_id : localStorage.user_id
    this.setState({ isLoading:true })
    getMeasuresForUser(this.state.measure_type_id, parseDateForAPI(startDate), parseDateForAPI(endDate), userID)
      .then((response) => {
        if (response.data) {
          if (this.state.isListMeasures) {
            this.setState({ listMeasures: response.data, isLoading: false })
          } else if (this.state.measure_type_id === 1) {
            this.setState({ systolicData: response.data })
            getMeasuresForUser(8, parseDateForAPI(startDate), parseDateForAPI(endDate), userID)
              .then((reponse) => {
                if (reponse.data) {
                  this.setState({ dataProvider: generateData(reponse.data, this.state.start_date, this.state.end_date, this.state.systolicData), isLoading: false })
                }
              })
          } else {
            this.setState({ dataProvider: generateData(response.data, this.state.start_date, this.state.end_date),isLoading: false }, () => {
              this.getModes()
            })
          }
        } else {
          console.log(`error while getting measures`)
        }
      })


  }

  changedStartDate(_startDate) {

    this.setState({ start_date: _startDate }, () => {
      this.getMeasures()
    })
  }

  changedEndDate(_endDate) {
    if (moment(this.state.start_date).diff(moment(_endDate)) <= 0) {
      this.setState({ end_date: _endDate }, () => {
        this.getMeasures()
      })
    } else {
      alert("End date needs to be after start date.")
    }
  }

  render() {
    if (this.state) {
      let chart = React.createElement(AmCharts.React, {
        className: "my-class",
        style: {
          width: "100%",
          height: "1000px"
        },
        options: {
          "type": "serial",
          "theme": "none",
          "marginRight": 45,
          "marginLeft": 45,
          "dataDateFormat": "YYYY-MM-DD",
          "autoMarginOffset": 20,
          "mouseWheelZoomEnabled": true,
          "valueAxes": [{
            "id": "v1",
            "axisAlpha": 0,
            "position": "left",
            "ignoreAxisWidth": true
          }],
          "graphs": [
            {
              "id": "g1",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g1",
              "balloonText": "<span style='font-size:18px;'>[[g1]]</span>"
            }
            ,
            {
              "id": "g2",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g2",
              "balloonText": "<span style='font-size:18px;'>[[g2]]</span>"
            },
            {
              "id": "g3",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g3",
              "balloonText": "<span style='font-size:18px;'>[[g3]]</span>"
            },
            {
              "id": "g4",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g4",
              "balloonText": "<span style='font-size:18px;'>[[g4]]</span>"
            },
            {
              "id": "g5",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g5",
              "balloonText": "<span style='font-size:18px;'>[[g5]]</span>"
            },
            {
              "id": "g6",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g6",
              "balloonText": "<span style='font-size:18px;'>[[g6]]</span>"
            },
            {
              "id": "g7",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g7",
              "balloonText": "<span style='font-size:18px;'>[[g7]]</span>"
            },
            {
              "id": "g8",
              "balloon": {
                "drop": true,
                "adjustBorderColor": false,
                "color": "#ffffff"
              },
              "bullet": "round",
              "bulletBorderAlpha": 1,
              "bulletColor": "#FFFFFF",
              "bulletSize": 5,
              "hideBulletsCount": 50,
              "lineThickness": 2,
              "title": "red line",
              "useLineColorForBulletBorder": true,
              "valueField": "g8",
              "balloonText": "<span style='font-size:18px;'>[[g8]]</span>"
            },
          ],
          "chartScrollbar": {
            "graph": "g1",
            "oppositeAxis": false,
            "offset": 30,
            "scrollbarHeight": 80,
            "backgroundAlpha": 0,
            "selectedBackgroundAlpha": 0.1,
            "selectedBackgroundColor": "#888888",
            "graphFillAlpha": 0,
            "graphLineAlpha": 0.5,
            "selectedGraphFillAlpha": 0,
            "selectedGraphLineAlpha": 1,
            "autoGridCount": true,
            "color": "#AAAAAA"
          },
          "chartCursor": {
            "pan": true,
            "valueLineEnabled": true,
            "valueLineBalloonEnabled": true,
            "cursorAlpha": 1,
            "cursorColor": "#258cbb",
            // "limitToGraph": "g1",
            "valueLineAlpha": 0.2,
            "valueZoomable": true
          },
          "valueScrollbar": {
            "oppositeAxis": false,
            "offset": 50,
            "scrollbarHeight": 10
          },
          "categoryField": "date",
          "categoryAxis": {
            "parseDates": moment(this.state.end_date).diff(moment(this.state.start_date)) === 0 ? false : true,
            "minPeriod": moment(this.state.end_date).diff(moment(this.state.start_date)) === 0 ? "mm" : "DD",
            "startOnAxis": true,
            "axisColor": "#DADADA",
            "gridAlpha": 0.07,
            "guides": this.state.guides,
          },
          "export": {
            "enabled": true,
            "dateFormat": "YYYY-MM-DD"
          },
          "dataProvider": this.state.dataProvider

        }
      })
      return (

        <div>
          <div className="datepicker-container">
            <DatePicker
              label="Start Date"
              selectYearsIntoPast={118}
              selectYearsIntoFuture={10}
              value={this.state.start_date}
              onChange={this.changedStartDate} />
            <DatePicker
              label="End Date"
              selectYearsIntoPast={118}
              selectYearsIntoFuture={10}
              value={this.state.end_date}
              onChange={this.changedEndDate} />
          </div>
          <div className="graph-container">
            {!this.state.isLoading && this.state.isListMeasures && this.state.listMeasures && this.getMeasuresList()}
            {!this.state.isLoading && !this.state.isListMeasures && chart}
            {this.state.isLoading && <Loading/>}
          </div>
        </div>

      )
    }
    else {
      <Loading />
    }

  }

  getMeasuresList() {
    return <div className="measures-list-container">
      <h1>Measures list</h1>
      {this.state.listMeasures.map((item, key) => (
        <div className="measure-box" key={key}>
          {moment(item.created_at).format('LLL')}
          {getImage(item)}
        </div>
      ))}
    </div>
  }

}

Measures.propTypes = {
  history: PropTypes.object,
  measure_type_id: PropTypes.object,
  location: PropTypes.object,
  user_id: PropTypes.number,
}
export default Measures;


// WEBPACK FOOTER //
// ./src/view/measures.js